export default function dateServiceFactory(services) {
  class PrintOSDate extends Date {
    constructor(...args) {
      super(...args);
    }

    getPrintOSDateString() {
      let year = `${this.getFullYear()}`;
      let month = this.getMonth() + 1 < 10 ? `0${this.getMonth() + 1}` : `${this.getMonth() + 1}`;
      let day = this.getDate() < 10 ? `0${this.getDate()}` : `${this.getDate()}`;
      return `${year}-${month}-${day}`;
    }

    getPrintOSUTCDateString() {
      let year = `${this.getUTCFullYear()}`;
      let month = this.getUTCMonth() + 1 < 10 ? `0${this.getUTCMonth() + 1}` : `${this.getUTCMonth() + 1}`;
      let day = this.getUTCDate() < 10 ? `0${this.getUTCDate()}` : `${this.getUTCDate()}`;
      return `${year}-${month}-${day}`;
    }

    dateOnly() {
      return new window.pDate(this.getFullYear(), this.getMonth(), this.getDate());
    }

    timeOnly() {
      return new window.pDate(0, 0, 0, this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds());
    }

    static fromPrintOSString(dateStr) {
      if (!dateStr) {
        return null;
      }

      let split = dateStr.split('-');
      if (split.length !== 3) {
        return null;
      }

      let y = Number(split[0]);
      let m = Number(split[1]) - 1;
      let d = Number(split[2]);
      return new window.pDate(y, m, d);
    }
  }

  return {
    init,
    getToday,
    getMonthName,
    getDayName,
    getDateFromString,
    getStringFromDate,
    getDateString,
    getDateStringFromUnix,
    getDateFromUnix,
    getUTCDateFromString,
    getUTCDateFromUnix,
    getUTCDate,
    getDateWithTime,
    getDateWithoutTime,
    getTimeStringFromDate,
    diffInDays,
    equal,
    greaterThanOrEqual,
    greaterThan,
    lessThanOrEqual,
    lessThan,
    isBetween,
    subtract,
    add,
    getTimeZoneOffsetString,
    getTimeZoneOffset,
    fromNow,
  };

  //////////////

  function init() {
    window.PDate = PrintOSDate;
  }

  function getToday() {
    return getUTCDateFromUnix(Date.now());
  }

  function getDateFromUnix(ms, includeTime = false) {
    let date = new Date(ms);
    return includeTime ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  }

  function getUTCDateFromUnix(ms, includeTime = false) {
    let date = new Date(ms);

    return getDateFromUnix(ms + date.getTimezoneOffset() * 60000, includeTime);
  }

  function getUTCDateFromString(dateStr) {
    return getUTCDate(new Date(dateStr));
  }

  function getUTCDate(date) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  function getDateFromString(dateStr) {
    if (!dateStr) {
      return null;
    }

    let split = dateStr.split('-');
    if (split.length !== 3) {
      return null;
    }

    let y = Number(split[0]);
    let m = Number(split[1]) - 1;
    let d = Number(split[2]);
    return new Date(y, m, d);
  }

  function getDateWithTime(date, time) {
    let split =  time.split(':');
    let hours = Number(split[0]);
    let minutes = Number(split[1]);
    return  new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0, 0);
  }

  function getDateWithoutTime(date) {
    let myDate = date ? date : new Date();
    return new Date(myDate.getFullYear(), myDate.getMonth(), myDate.getDate(), 0, 0, 0);
  }

  function getStringFromDate(date) {
    let year = `${date.getFullYear()}`;
    let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    let day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
    return `${year}-${month}-${day}`;
  }

  function getTimeStringFromDate(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  }

  function getMonthName(date, locale, option = 'long') {
    const myLocale = locale ? locale : services.i18n.getLocale();
    return date.toLocaleString(myLocale, { month: option});
  }

  function getDayName(date, locale, option = 'long') {
    const myLocale = locale ? locale : services.i18n.getLocale();
    return date.toLocaleString(myLocale, { weekday: option});
  }

  function getDateStringFromUnix(unix, includeTime = false, options = {dateStyle: 'long'}, formatOptions = {}) {
    let myDate = getDateFromUnix(unix, includeTime);
    return getDateString(myDate, null, options);
  }

  function getDateString(date, locale, options = {dateStyle: 'long'}, formatOptions = {}) {
    const myLocale = locale ? locale : services.i18n.getLocale();
    return new Intl.DateTimeFormat(myLocale, options).format(date, formatOptions);
  }

  function diffInDays(date1, date2) {
    let d1s = getStringFromDate(date1);
    let d2s = getStringFromDate(date2);
    let d1 = new Date(d1s);
    let d2 = new Date(d2s);
    return Math.abs(d1 - d2) / (1000*60*60*24);
  }

  function subtract(date, units, unit = 'days') {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    switch (unit) {
      case 'years':
        return new Date(year - units, month, day);
      case 'months':
        return new Date(year, month - units, day);
      case 'days':
        return new Date(year, month, day - units);
    }
  }

  function add(date, units, unit = 'days') {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    switch (unit) {
      case 'years':
        return new Date(year + units, month, day);
      case 'months':
        return new Date(year, month + units, day);
      case 'days':
        return new Date(year, month, day + units);
    }
 }

  function equal(date1, date2, fidelity = 'day') {
    let src;
    let test;
    switch (fidelity) {
      case 'year':
        src = new Date(date1.getFullYear());
        test = new Date(date2.getFullYear());
        return !(src > test) && !(src < test);
      case 'month':
        src = new Date(date1.getFullYear(), date1.getMonth());
        test = new Date(date2.getFullYear(), date2.getMonth());
        return !(src > test) && !(src < test);
      case 'day':
        src = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        test = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return !(src > test) && !(src < test);
    }
  }

  function greaterThanOrEqual(date1, date2, fidelity = 'day') {
    let src;
    let test;
    switch (fidelity) {
      case 'year':
        src = new Date(date1.getFullYear());
        test = new Date(date2.getFullYear());
        return src >= test || ( !(src >= test) && !(src <= test) );
      case 'month':
        src = new Date(date1.getFullYear(), date1.getMonth());
        test = new Date(date2.getFullYear(), date2.getMonth());
        return src >= test || ( !(src >= test) && !(src <= test) );
      case 'day':
        src = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        test = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return src >= test || ( !(src >= test) && !(src <= test) );
    }
  }

  function greaterThan(date1, date2, fidelity = 'day') {
    let src;
    let test;
    switch (fidelity) {
      case 'year':
        src = new Date(date1.getFullYear());
        test = new Date(date2.getFullYear());
        return src > test;
      case 'month':
        src = new Date(date1.getFullYear(), date1.getMonth());
        test = new Date(date2.getFullYear(), date2.getMonth());
        return src > test;
      case 'day':
        src = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        test = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return src > test;
    }
  }

  function lessThanOrEqual(date1, date2, fidelity = 'day') {
    let src;
    let test;
    switch (fidelity) {
      case 'year':
        src = new Date(date1.getFullYear());
        test = new Date(date2.getFullYear());
        return src <= test || ( !(src >= test) && !(src <= test) );
      case 'month':
        src = new Date(date1.getFullYear(), date1.getMonth());
        test = new Date(date2.getFullYear(), date2.getMonth());
        return src <= test || ( !(src >= test) && !(src <= test) );
      case 'day':
        src = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        test = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return src <= test || ( !(src >= test) && !(src <= test) );
    }
  }

  function lessThan(date1, date2, fidelity = 'day') {
    let src;
    let test;
    switch (fidelity) {
      case 'year':
        src = new Date(date1.getFullYear());
        test = new Date(date2.getFullYear());
        return src < test;
      case 'month':
        src = new Date(date1.getFullYear(), date1.getMonth());
        test = new Date(date2.getFullYear(), date2.getMonth());
        return src < test;
      case 'day':
        src = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        test = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return src < test;
    }
  }

  function isBetween(date, start, end) {
    return date >= start && date <= end;
  }

  function getTimeZoneOffsetString(timeZone) {
    let test = new Date().toLocaleString('en', {timeZone, timeZoneName: 'longOffset'});
    let split = test.split(' ');
    return split[3];
  }

  function getTimeZoneOffset(timeZone) {
    let tzo = getTimeZoneOffsetString(timeZone);
    let [_,h,m] = tzo.match(/([+-]\d+):(\d+)$/) || ['', '+00', '00'];
    return h * 60 + (h > 0 ? +m : -m);
  }

  function fromNow(timeStamp) {
    let now = Date.now();
    let delta = timeStamp > now ? 0 : Date.now() - timeStamp;
    if (delta <= (44 * 1000)) {
      return services.i18n.$t('header.date.fewSecondsAgo');
    }
    else if (delta <= (89 * 1000)) {
      return services.i18n.$t('header.date.minuteAgo');
    }
    else if (delta <= (44 * 60 * 1000)) {
      return services.i18n.$t('header.date.minutesAgo', [Math.round(delta / 60000)]);
    }
    else if (delta <= (89 * 60 * 1000)) {
      return services.i18n.$t('header.date.hourAgo');
    }
    else if (delta <= (21 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.hoursAgo', [Math.round(delta / 3600000)]);
    }
    else if (delta <= (36 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.dayAgo');
    }
    else if (delta <= (25 * 24 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.daysAgo', [Math.round(delta / 86400000)]);
    }
    else if (delta <= (45 * 24 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.monthAgo');
    }
    else if (delta <= (345 * 24 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.monthsAgo', [Math.round(delta / 2592000000)]);
    }
    else if (delta <= (545 * 24 * 60 * 60 * 1000)) {
      return services.i18n.$t('header.date.yearAgo');
    }
    else {
      return services.i18n.$t('header.date.yearsAgo', [Math.round(delta / 31536000000)]);
    }
  }
}
